import styled from '@emotion/styled';
import { Stack } from '@caudena/web-platform'

export const HighlightedLinkWrapper = styled.div`
  overflow: hidden;
`
export const HighlightedWrapper = styled(Stack)`
  overflow: hidden;
`
